import { render } from "./SelectedList.vue?vue&type=template&id=d46dd8be"
import script from "./SelectedList.vue?vue&type=script&lang=js"
export * from "./SelectedList.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__